import React, {Component} from 'react';

import {Link, withRouter} from 'react-router-dom';

import exampleAnswer from '../assets/images/placeholder.png'

class QuizInstructions extends Component {

    constructor() {
        super();

        this.state = {
            testButtonClicked: true,
            triedAndfailedtoAdvance: false,
        };
    }

    render() {
        return (
            <section className="instructions">
                <header className="page-info">
                    <h1 className="page-title">Audition</h1>
                    <h2 className="current-song-title">Current Song: <p>{this.props.songTitle}</p></h2>
                    <p className="narrative">It’s audition time! Before you start stepping, brushing, and bombershaying under the lights, we
                        need to test your knowledge of this musical! So as they say in the theatre, break a leg!</p>
                </header>

                <h2>Instructions</h2>
                <section className="content">
                    <article className="main-content">
                        <p>Your audition is a three-question quiz about the song you selected or the musical it’s from.
                            You will have 60 seconds to answer each question. Click on the answer that you believe is
                            correct. </p>

                    </article>

                    {/* <aside>
                        <h1 className={"try-it bounce "+ (!this.state.testButtonClicked ? "animated" : "")}>TRY IT</h1>
                        <button className={"button-primary "+(this.state.testButtonClicked ? "quiz-answers-selected" : "") + (this.state.triedAndfailedtoAdvance ? " wobble animated" : "")}
                                onClick={() => {
                                    this.setState({
                                        testButtonClicked: true
                                    });
                                }}

                                onAnimationEnd={() => {
                                    this.setState({
                                        triedAndfailedtoAdvance: false,
                                    });
                                }}
                        >answer 1</button>
                        <p>click on the correct answer</p>
                    </aside> */}

                </section>

                <footer className="page-footer">
                    <Link className='button-primary button-exit' to="/songs">Exit </Link>
                    <Link className="button-primary" to="/fact">Skip</Link>

                    <button className={'button-primary '+(this.state.testButtonClicked ? "" : "button-primary-inactive")}
                            onClick={() => {
                                if(this.state.testButtonClicked) {
                                    this.props.history.push("/quiz");
                                }

                                else{
                                    this.setState({triedAndfailedtoAdvance : true})
                                }
                            }}
                    >Next</button>
                </footer>
            </section>
        );
    }
}
export default withRouter(QuizInstructions);



// WEBPACK FOOTER //
// ./src/components/QuizInstructions.js